import { InjectionToken } from '@angular/core';
export var NB_SECURITY_OPTIONS_TOKEN = new InjectionToken('Nebular Security Options');
//# sourceMappingURL=security.options.js.map